




import GenericProductDetails from "@/components/products/GenericProductDetails.vue";
import { ProductDetailsContainerModel } from "@/models/cluster";
import { Component, Vue } from "vue-property-decorator";
import { PredictiveMaintenanceModel } from "./PredictiveMaintenanceModel";
@Component({
  components: {
    GenericProductDetails
  }
})
export default class AssetManager extends Vue {
  get container(): ProductDetailsContainerModel {
    return new PredictiveMaintenanceModel(this.$i18n);
  }
}
